import CultureCard, { Props as CultureCardProps } from '.';
import { primary } from '@styles/Colors';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from '@emotion/styled';

import 'swiper/css';

const CultureCardListWrapper = styled.div`
  width: 100%;

  .swiper-slide {
    width: auto;
  }
`;

const items: CultureCardProps[] = [
  {
    cardNumber: '01',
    title: '언제나 즐겁게 열정적으로\n일합니다',
    image: {
      src: '/assets/images/10doing_1.png',
      width: 348,
      height: 150,
    },
    contents: [
      '후회를 남기지 않고 열정적으로 일하면\n나와 MOM 모두 성장합니다',
      '언제나 즐겁게 일할 수 있도록 긍정적이고 적극적으로\n일합니다',
      '출근이 기다려질 만큼\n일과 피플이 모두 다 만족스러운 MOM을 만듭니다',
    ],
  },
  {
    cardNumber: '02',
    leftBackgroundColor: primary.gray,
    title: '작은 불편함도 절대\n지나치지 않습니다',
    image: {
      src: '/assets/images/10doing_2.png',
      width: 366,
      height: 150,
      style: {
        paddingBottom: '24px !important',
      },
    },
    contents: [
      '작은 불편함부터 해결하기 어려운 문제들까지\n지나치지 않고 해결책을 찾습니다',
      '누구나 주도적으로 의견을 제시하고,\n동료의 의견까지 헌신적으로 수용합니다',
      '‘누군가 하겠지‘하는 사고를 지양하며, 회피하지 않고\n먼저 나섭니다',
    ],
  },
  {
    cardNumber: '03',
    title: '동료의 아이디어를\n존중합니다',
    image: {
      src: '/assets/images/10doing_3.png',
      width: 212,
      height: 150,
      style: {
        paddingBottom: '24px !important',
      },
    },
    contents: [
      '동료의 아이디어를 무시하지 않고, 납득이 될 때따지 묻고\n이해하며 의견을 더합니다',
      '나와 동료의 의견이 다를때, 포용적으로 논의합니다',
      '이해가 되면 적극적으로 수렴하고 협업합니다',
    ],
  },
  {
    cardNumber: '04',
    leftBackgroundColor: primary.blue,
    title: '해결책은 반드시\n지원과 보상을 받습니다',
    image: {
      src: '/assets/images/10doing_4.png',
      width: 440,
      height: 150,
    },
    contents: [
      '회사는 미션을 실행하기 위한 모든 지원을 합니다',
      '성장을 동반한 성공에는 반드시 보상을 받습니다',
      '성과를 개별적으로 측정하여 능력별 연봉 및 인센티브를\n차등지급 합니다',
    ],
  },
  {
    cardNumber: '05',
    title: '성공과 실패를\n기록하고 기업합니다',
    image: {
      src: '/assets/images/10doing_5.png',
      width: 128,
      height: 150,
      style: {
        paddingBottom: '24px !important',
      },
    },
    contents: [
      '해결책의 성공과 실패를 기준을 갖고 판별합니다',
      '반드시 검증 과정을 통해 성공과 실패의 이유를 찾습니다',
      '기준과 검증을 통해 성공과 실패를 분석하여 추후\n올바른 결정을 내립니다',
    ],
  },
  {
    cardNumber: '06',
    leftBackgroundColor: primary.gray,
    title: '실패한 도전도\n우리의 자산입니다',
    image: {
      src: '/assets/images/10doing_6.png',
      width: 261,
      height: 150,
    },
    contents: [
      '불편을 해결하기 위해 도전하고 실패를 두려워하지\n않습니다',
      '실패한 도전은 혁신의 밑거름입니다',
      '최선을 다한 도전은 어떤 상황에도 비난 받지 않습니다',
      '나부터 좋은 영향을 주는 사람이 되겠습니다',
    ],
  },
  {
    cardNumber: '07',
    leftBackgroundColor: primary.blue,
    title: '밀도 높은 몰입으로\n최대한 성과를 창출합니다',
    image: {
      src: '/assets/images/10doing_7.png',
      width: 271,
      height: 150,
    },
    contents: [
      'MOM의 미션을 달성하기 위해 매 순간 몰입합니다',
      '자율을 기반으로 최고로 집중하여 일을 해결합니다',
      '어디서든 떳떳하게 일합니다',
      '결과물 제시와 대한 책임은 나에게 있습니다',
    ],
  },
  {
    cardNumber: '08',
    title: '솔직하고 논리적인\n의사소통을 멈추지 않습니다',
    image: {
      src: '/assets/images/10doing_8.png',
      width: 326,
      height: 150,
    },
    contents: [
      '의사소통을 통한 협업을 추구하며,\n모든 동료에게 논리적인 의견을 제시합니다',
      '솔직하고 진정성 있게 대하고 소통의 기본인 매너를 갖춥니다',
      '온전히 이해하지 못한 사항을 숨기지 않으며,\n끝까지 확인합니다',
      '논의 후 결정된 사랑은 모든 역량을 다해 실행합니다',
    ],
  },
  {
    cardNumber: '09',
    title: '동료는 어디에나 존재하며\n서로의 신뢰를 얻습니다',
    image: {
      src: '/assets/images/10doing_9.png',
      width: 128,
      height: 150,
      style: {
        paddingBottom: '24px !important',
      },
    },
    contents: [
      '고객은 우리의 비전을 달성하기 위한 회사 밖의 동료입니다',
      '리더는 명확한 방향을 제시하고 판단하며,\n피플의 의견을 존중하며 지원하고, 결과에 책임을 집니다',
      '피플은 내 편의와 이익이 아닌 성과창출을 위한\n의견을 제시하고, 리더를 믿고 실행합니다',
      '우리가 일하는 규칙과, 동료 간의 약속을 지키면서 일합니다',
    ],
  },
  {
    cardNumber: '10',
    title: '인생의 모든 것은 연관되어 있으며 동시에 가치있습니다',
    image: {
      src: '/assets/images/10doing_10.png',
      width: 440,
      height: 150,
      style: {
        paddingTop: '66px !important',
      },
    },
    contents: [
      'MOM의 목표달성을 위한 일, 팀의 프로젝트에 의한 일,\n나의 꿈을 위한 일을 명확히 합니다',
      '주도적으로 과정을 설계하고 목표를 향해\n최선을 다해 달려갑니다',
      '동료와의 관계, 업무에 대한 불만족은 부정적으로\n전파하지 않고, 동료와 함께 해결합니다',
    ],
  },
];

export default function CultureCardList() {
  return (
    <>
      <CultureCardListWrapper>
        <Swiper spaceBetween={40} slidesPerView={'auto'}>
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <CultureCard {...item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </CultureCardListWrapper>
    </>
  );
}
